<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button size="medium" type="primary" @click="jumpToPage('moduleAppAddEdit')" v-if="isShowByPermission('/wyms/module/insertModule')">注册应用</el-button>
            <el-select size="medium" v-model="isIntegrate" @change="getList">
                <el-option :key="1" label="系统应用" :value="1"></el-option>
                <el-option :key="2" label="集成应用" :value="2"></el-option>
            </el-select>
            <el-select size="medium" v-model="systemType" @change="getList">
                <el-option :key="2" label="微校+" :value="2"></el-option>
                <el-option :key="3" label="成长乐园" :value="3"></el-option>
            </el-select>
            <span v-show="systemType == 2">
            <el-select size="medium" v-model="schoolType" @change="getList">
                <el-option :key="0" label="全部学校类型" :value="''"></el-option>
                <el-option :key="12" label="通用" :value="12"></el-option>
                <el-option :key="1" label="幼儿园" :value="1"></el-option>
                <el-option :key="2" label="中小学" :value="2"></el-option>
                <el-option :key="5" label="教育局" :value="5"></el-option>
            </el-select>
            </span>

            <el-input size="medium" class="search-input search-input--right" placeholder="应用名称/应用编码"
                      v-model="moduleName" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>
        <div >
            <el-table
                :height="windowHeight - 220"
                :data="dataList" border
                style="width: 100%"
            >
                <el-table-column
                    prop="title"
                    label="应用名称"
                    align="center"
                >
                    <template slot-scope="scope">
                        <router-link v-if="scope.row.isIntegrate == 2" :to="{
                                path: '/main/developmentSystem/permissionSystem/moduleApp/moduleAppIntDetail',
                                query: {
                                    id: scope.row.id
                                }
                            }">
                            {{ scope.row.name }}
                        </router-link>
                        <span v-else>{{scope.row.name}}</span>
                    </template>

                </el-table-column>
                <el-table-column
                    label="应用编码"
                    prop="code"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="应用类型"
                    prop="moduleTypeName"
                    align="center"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    label="适用平台"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ ['', '通用', '微校+', '成长乐园'][scope.row.systemType] }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="适用学校"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ {
                        1: '幼儿园',
                        2: '中小学',
                        5: '教育局',
                        12: '通用'
                        }[scope.row.schoolType] }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" v-if="isShowByPermission('/wyms/module/getUsedSchoolsZ')" @click="jumpToPage('moduleAppSchool', {id: scope.row.id})">学校</el-button>
                        <el-button type="text" v-if="isShowByPermission('/wyms/module/updateModule')" @click="jumpToPage('moduleAppAddEdit', {id: scope.row.id})">编辑
                        </el-button>
                        <el-button type="text" v-if="isShowByPermission('/wyms/module/deleteModule')" @click="deleteHandler(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        queryModuleList,
        deleteModule
    } from '@/api/moduleApp';

    export default {
        name: "moduleAppList",
        data() {
            return {
                isIntegrate: 1,
                systemType: 2,
                schoolType: '',
                moduleName: '',
                dataList: []
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.queryModuleListFunc()
            });
        },
        mixins: [windowResize, baseMixin],
        methods: {
            isShowByPermission,
            getList() {
                this.pagination.pageNo = 1;
                this.queryModuleListFunc();
            },
            sizeChangeHandler() {
                this.queryModuleListFunc();
            },
            currentChangeHandler() {
                this.queryModuleListFunc();
            },
            deleteHandler(id) {
                this.$confirm("确认要删除吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    deleteModule({
                        id
                    })
                        .then(() => {
                            this.queryModuleListFunc();
                        })
                });
            },
            queryModuleListFunc() {
                queryModuleList({
                    isIntegrate: this.isIntegrate,
                    systemType: this.systemType,
                    schoolType: this.systemType == 2 ? this.schoolType : '',
                    moduleName: this.moduleName,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize
                })
                    .then(data => {
                        this.dataList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>

<style lang="scss">
    #moduleAppList {
       padding:12px;
        .top {
    padding-bottom: 10px;
    .el-select{
        width:150px;
    }
  }
        a {
            color: #409EFF;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppList.vue